import ReviewCard from '@c/cards/ReviewCard';
import { useQuery } from '@tanstack/react-query';
import { filterVisibleReviews, getReviewsByUid } from '@util/firestore/reviews';
import { getUserById } from '@util/firestore/users';
import Link from 'next/link';
import { useMemo } from 'react';
import Carousel from './Carousel';
import PageSectionHeader from './PageSectionHeader';

const MeetTheSellerCarousel = ({ seller_id }: { seller_id: string }) => {
  const { data: reviews } = useQuery(
    ['reviews', seller_id],
    () => getReviewsByUid(seller_id),
    {
      enabled: !!seller_id,
    }
  );

  const { data: sellerDoc } = useQuery(
    ['seller', seller_id],
    () => getUserById(seller_id),
    {
      enabled: !!seller_id,
    }
  );

  // Filter reviews to respect 14-day blind period
  const visibleReviews = useMemo(
    () => filterVisibleReviews(reviews || []),
    [reviews]
  );

  if (!visibleReviews || visibleReviews.length === 0) return null;

  return (
    <div className="mx-auto mt-[6.4rem] max-w-default px-[0.8rem] sm:px-default-padding-x">
      <div className="block sm:hidden">
        <PageSectionHeader title="Seller Reviews"></PageSectionHeader>
      </div>
      <div className="hidden sm:block">
        <PageSectionHeader
          title="Seller Reviews"
          href={`/shop-seller/${sellerDoc?.username_slug}`}
          linkText="View All Reviews"
        ></PageSectionHeader>
      </div>

      <div className="flex flex-col items-center gap-[6.4rem] lg:flex-row">
        {/* <SellerCard /> */}
        <Carousel
          items={
            visibleReviews.map((review) => (
              <ReviewCard key={review.id} review={review} />
            )) ?? []
          }
        />
      </div>
      <div className="mt-[3.2rem] block text-center font-semibold text-brand-secondary sm:hidden">
        <Link href="/">View All Reviews</Link>
      </div>
    </div>
  );
};

export default MeetTheSellerCarousel;
